import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmGsConfigProviderEntrypointProps } from './JsmGsConfigProvider.entrypoint.types.tsx';

type RequestTypesSettingsConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JsmGsConfigProviderEntrypointProps,
	{} | null
>;

export const requestTypesSettingsConfigProviderEntrypoint: EntryPoint<
	RequestTypesSettingsConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<RequestTypesSettingsConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-jsm-gs-request-types-settings-provider" */ './RequestTypesSettingsConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
